export const BASE_URL = '';
export const WRAPPED_SOL_ADDRESS = 'So11111111111111111111111111111111111111112';
export const SOL_ADDRESS = '11111111111111111111111111111111';
export const SUPPORTED_NETWORKS = ['solana'];
export const Urls = {
    Tokens: new URL('https://cache.jup.ag/tokens'),
    Quotes: new URL('https://quote-api.jup.ag/v6/quote'),
    Swap: new URL('https://quote-api.jup.ag/v6/swap'),
    Price: new URL('https://price.jup.ag/v6/price'),
};
export const SVC = 'jup-sol';
export const DEFAULT_SLIPPAGE = 2;
export const NEW_TOKEN_ACCOUNT_FEE = 0.003;
export const REFERRAL_PROGRAM_ID = 'REFER4ZgmyYx9c6He5XfaTMiGfdLwRnkV4RPp9t9iF3';
export const DEFAULT_REFERRAL_PROGRAM_ADDRESS = 'H6Pm5uF5TC9F85vcJNZufM2z7fE3eDz5CG43sGAr7P8w';
export const DEFAULT_FEE_PERCENTAGE = 0.85;
export const ORIGIN = 'https://jup.ag';
